import type { PdfAnnotation } from "./types";
import { normRectToAbsolute } from "../utils/rects";

type Props = {
  pageWidth: number;
  pageHeight: number;
  annotations: PdfAnnotation[];
  onOpen: (annotation: PdfAnnotation) => void;
  currentUserId?: string;
};

const typeColors: Record<PdfAnnotation["type"], string> = {
  highlight: "bg-warning/30 hover:bg-warning/40",
  note: "bg-info/30 hover:bg-info/40",
  explain: "bg-premium/30 hover:bg-premium/40",
};

const otherUserColors: Record<PdfAnnotation["type"], string> = {
  highlight: "bg-warning/20 hover:bg-warning/25 border border-warning/30",
  note: "bg-info/20 hover:bg-info/25 border border-info/30",
  explain: "bg-premium/20 hover:bg-premium/25 border border-premium/30",
};

export function PdfAnnotationLayer({
  pageWidth,
  pageHeight,
  annotations,
  onOpen,
  currentUserId,
}: Props) {
  return (
    <div className="pointer-events-none absolute inset-0 z-20">
      {annotations.map((a) => {
        const isOtherUser = currentUserId && a.userId !== currentUserId;
        const colors = isOtherUser ? otherUserColors[a.type] : typeColors[a.type];

        return (
          <div key={a.id} className="absolute inset-0">
            {a.rects.map((r, idx) => {
              const abs = normRectToAbsolute(r, pageWidth, pageHeight);

              return (
                <button
                  key={idx}
                  type="button"
                  className={`pointer-events-auto absolute rounded-sm transition-colors ${colors} ${isOtherUser ? "opacity-60" : ""}`}
                  style={{
                    left: abs.left,
                    top: abs.top,
                    width: abs.width,
                    height: abs.height,
                  }}
                  onClick={() => onOpen(a)}
                  aria-label={`Open ${a.type} annotation${isOtherUser ? " (teammate)" : ""}`}
                />
              );
            })}
          </div>
        );
      })}
    </div>
  );
}
